import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats superscript by wrapping the content in superscript HTML tags
 */
@Pipe({
  name: 'tdWbFinePrintSuperscript'
})
export class FinePrintSuperscriptPipe implements PipeTransform {

  transform(value: string | Array<string>): string {
    let superscript: string;

    if ((typeof value === 'string' || value instanceof Array) && value.length > 0) {
      if (value instanceof Array) {
        superscript = value.join(', ');
      } else {
        superscript = value;
      }
      return '<sup aria-hidden="true">' + superscript + '</sup><sup class="td-wb-vh" aria-hidden="false">(' + superscript + ')</sup>';
    }
    return '';  // return empty string if no value provided

  }

}
